import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

import "./PdfPrescricaoModelo2.scss";
import moment from "moment/moment";

function PdfPrescricaoKDent({ prescricaoData, showPreviousPage }) {
  const navigate = useNavigate();

  const { cliente, clinica, data } = prescricaoData;

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Prescrição-${prescricaoData.cliente.nome}_${moment(
      new Date(),
    ).format("DD-MM-YYYY")}`,
    onAfterPrint: () => {
      showPreviousPage();
      navigate(`/clientes/${prescricaoData.cliente._id}-prescricao`);
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  let tempQtddExt = data.map((dt) => Number(dt.quantidade));

  tempQtddExt.forEach((qt, i) => {
    switch (qt) {
      case 1:
        tempQtddExt[i] = "Uma";
        break;
      case 2:
        tempQtddExt[i] = "Duas";
        break;
      case 3:
        tempQtddExt[i] = "Três";
        break;
      case 4:
        tempQtddExt[i] = "Quatro";
        break;
      case 5:
        tempQtddExt[i] = "Cinco";
        break;
      case 6:
        tempQtddExt[i] = "Seis";
        break;
      case 7:
        tempQtddExt[i] = "Sete";
        break;
      case 8:
        tempQtddExt[i] = "Oito";
        break;
      case 9:
        tempQtddExt[i] = "Nove";
        break;
      case 10:
        tempQtddExt[i] = "Dez";
        break;
      default:
        return qt;
    }
  });

  return (
    <>
      <div
        ref={componentRef}
        className={`kdent-pdf-wrapper${prescricaoData.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " kdent-pdf-wrapper--pretoebranco" : ""}`}
      >
        {/* Cabeçalho: brasão + título */}
        <div className="kdent-republicaDeCv">
          <img
            src="/images/republica-cv.png"
            alt=""
            className="kdent-republicaDeCv__img"
          />
          <span className="kdent-republicaDeCv__text">
            República de Cabo Verde – Receita Médica
          </span>
        </div>

        <div className="kdent-pdf-body">
          {/* TOPO */}
          <div className="kdent-pdf-prescricao__cabecalho">
            {/* Coluna esquerda — logo + dados fixos do K·DENT */}
            <div className="kdent-pdf-prescricao__cabecalho--left">
              <img
                className="kdent-pdf-prescricao__logo-clinica"
                src={`${process.env.REACT_APP_BACKEND_LINK}/${clinica.logotipo}`}
                alt="K·DENT"
              />
              {/* Morada, telefones e email vêm SÓ dos dados — os da unidade,
                  pelo `dadosImpressao`. Este cabeçalho foi escrito quando a
                  K Dent tinha um só local, e cada campo tinha como recurso um
                  dado da Praia escrito aqui; o bairro nem sequer era campo.
                  Com duas unidades, uma receita da Assomada saía a dizer
                  «Achada Santo António» e com um telefone da Praia. Um valor
                  que falta fica em branco, em vez de ser emprestado de outra
                  cidade. */}
              <span>{clinica.nome ? clinica.nome : "K DENT"}</span>
              {clinica.endereco && <span>{clinica.endereco}</span>}
              {(clinica.cidade || clinica.ilha) && (
                <span>
                  {[clinica.cidade, clinica.ilha && `Ilha de ${clinica.ilha}`]
                    .filter(Boolean)
                    .join(" - ")}
                </span>
              )}
              <span>
                Cabo Verde
                {[clinica.contacto, clinica.contacto2, clinica.contacto3].some(
                  Boolean,
                ) &&
                  ` - ${[clinica.contacto, clinica.contacto2, clinica.contacto3]
                    .filter(Boolean)
                    .join(" / ")}`}
              </span>
              {clinica.email && <span>E-mail: {clinica.email}</span>}
              <span>NIF: {clinica.nif ? clinica.nif : "286 016 605"}</span>
            </div>

            {/* Coluna direita — identificação do utente */}
            <div className="kdent-pdf-prescricao__cabecalho--right">
              <span className="kdent-pdf-prescricao__cabecalho--right__title">
                Identificação do Utente
              </span>
              <div className="kdent-pdf-prescricao__cabecalho--right__campo">
                <span className="kdent-pdf-prescricao__cabecalho--right__campo--semiBold">
                  Nome:
                </span>
                <span className="normalSpan">{cliente.nome}</span>
              </div>
              <div className="kdent-pdf-prescricao__cabecalho--right__campo">
                <span className="kdent-pdf-prescricao__cabecalho--right__campo--semiBold">
                  Data de Nascimento:
                </span>
                <span className="normalSpan">{cliente.data_nasc || ""}</span>
                <span
                  className="kdent-pdf-prescricao__cabecalho--right__campo--semiBold"
                  style={{ marginLeft: "10px" }}
                >
                  Tel.:
                </span>
                <span className="normalSpan">{cliente.contacto}</span>
              </div>
              <div className="kdent-pdf-prescricao__cabecalho--right__campo">
                <span className="kdent-pdf-prescricao__cabecalho--right__campo--semiBold">
                  Endereço:
                </span>
                <span className="normalSpan">{cliente.endereco}</span>
              </div>
              <div className="kdent-pdf-prescricao__cabecalho--right__campo">
                <span className="kdent-pdf-prescricao__cabecalho--right__campo--semiBold">
                  Entidade Responsável:
                </span>
                <span className="normalSpan"></span>
              </div>
              <div className="kdent-pdf-prescricao__cabecalho--right__campo">
                <span className="kdent-pdf-prescricao__cabecalho--right__campo--semiBold">
                  Nº do Beneficiário:
                </span>
                <span className="normalSpan">
                  {cliente.nr_beneficiario ? cliente.nr_beneficiario : ""}
                </span>
              </div>
            </div>
          </div>

          {/* MEIO */}
          <div className="kdent-pdf-prescricao__middle">
            <div className="kdent-pdf-prescricao__middle--left">
              <div className="kdent-smallDiv--1st">
                <div className="kdent-tinyDiv">
                  <span className="kdent-rx-r">R</span>
                  <span className="kdent-rx-x">X</span>
                </div>
                <div className="kdent-smallDiv--1st-txt">
                  <div>
                    Denominação Comum Internacional (DCI) da Substância activa,
                  </div>
                  <div>
                    Dosagem, forma farmacêutica, posologia e duração de
                    tratamento
                  </div>
                </div>
              </div>

              {data.map((dt, index) => (
                <div
                  className="kdent-pdf-prescricao__middle__data kdent-pdf-prescricao__middle__data--itemPrescricao"
                  key={`kdent-pdf-prescricao__middle__data-${index}`}
                >
                  <div>{`${
                    dt.medicamento.nome ? dt.medicamento.nome : dt.medicamento
                  } - ${dt.tipo}`}</div>
                  <div className="kdent-pdf-prescricao__middle__data--2">
                    {`${dt.posologia}${
                      dt.duracao
                        ? ` durante ${dt.duracao} ${
                            dt.duracao > 1 ? "dias" : "dia"
                          }`
                        : ""
                    }`}
                  </div>
                </div>
              ))}
            </div>

            <div className="kdent-pdf-prescricao__middle--right">
              <div className="kdent-pdf-prescricao__middle--right-number">
                <div className="kdent-smallDiv kdent-smallDiv--top">Nº</div>
                {data.map((dt, index) => (
                  <div
                    className="kdent-pdf-prescricao__middle__data kdent-pdf-prescricao__middle__data--center"
                    key={`kdent-pdf-prescricao__middle__data--center1-${index}`}
                  >
                    {dt.quantidade}
                  </div>
                ))}
              </div>
              <div className="kdent-pdf-prescricao__middle--right-extenso">
                <div className="kdent-smallDiv kdent-smallDiv--top">
                  Extenso
                </div>
                {tempQtddExt.map((qt, index) => (
                  <div
                    className="kdent-pdf-prescricao__middle__data kdent-pdf-prescricao__middle__data--center"
                    key={`kdent-pdf-prescricao__middle__data--center2-${index}`}
                  >
                    {qt}{" "}
                    {data[index].tipo === "Frasco" ||
                    data[index].tipo === "Xarope"
                      ? "Frasco"
                      : "Emb."}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RODAPÉ DO FORMULÁRIO */}
          <div className="kdent-pdf-prescricao__bottom">
            <div className="kdent-pdf-prescricao__bottom--left">
              {/* Médico */}
              <div className="kdent-pdf-prescricao__bottom--left--1">
                <div className="kdent-smallDiv kdent-smallDiv--bold kdent-smallDiv--bottom">
                  Médico
                </div>
                <div className="kdent-div__carimbo">
                  <span className="kdent-pdf-prescricao__bottom-top-span">
                    Carimbo ou Vinheta
                  </span>
                </div>
                <div className="kdent-assinaturaEData">
                  {prescricaoData.medico?.assinatura?.ativa &&
                  prescricaoData.medico?.assinatura?.autorizacoes
                    ?.prescricoes &&
                  prescricaoData.medico?.assinatura?.imagem ? (
                    <img
                      src={`${process.env.REACT_APP_BACKEND_LINK}/${prescricaoData.medico.assinatura.imagem}`}
                      alt="Assinatura"
                      className="kdent-assinatura-img"
                      style={{
                        maxHeight: "50px",
                        maxWidth: "150px",
                        objectFit: "contain",
                        display: "block",
                        margin: "4px 0",
                      }}
                    />
                  ) : (
                    <hr />
                  )}
                  <span className="kdent-assinatura">Assinatura</span>
                  <span
                    className="kdent-data"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      gap: "2px",
                    }}
                  >
                    <span className="kdent-data-line">Data:</span>
                    <span className="kdent-data-line">
                      {moment(new Date()).format("DD / MM / YYYY")}
                    </span>
                  </span>
                </div>
              </div>

              {/* Farmácia */}
              <div className="kdent-pdf-prescricao__bottom--left--2">
                <div className="kdent-smallDiv kdent-smallDiv--bold kdent-smallDiv--bottom">
                  Farmácia
                </div>
                <div className="kdent-div__carimbo">
                  <span className="kdent-pdf-prescricao__bottom-top-span">
                    Carimbo
                  </span>
                </div>
                <div className="kdent-assinaturaEData">
                  <hr />
                  <span className="kdent-assinatura">
                    Assinatura do Farmacêutico
                  </span>
                  <span className="kdent-data">Data:</span>
                  <span className="kdent-data-line">
                    __________ / __________ / __________
                  </span>
                </div>
              </div>
            </div>

            {/* Utente */}
            <div className="kdent-pdf-prescricao__bottom--right">
              <div
                className="kdent-smallDiv kdent-smallDiv--bold kdent-smallDiv--bottom"
                style={{ width: "100%" }}
              >
                Utente
              </div>
              <span className="kdent-pdf-prescricao__bottom--right__span1">
                Declaro que manifestei o Direito de Opção
              </span>
              <span className="kdent-pdf-prescricao__bottom--right__span2">
                Assinatura
              </span>
            </div>
          </div>

          {/* VALIDADE */}
          <div className="kdent-pdf-prescricao__rodape">
            <span className="kdent-pdf-prescricao__rodape--bold prescricao__rodape--1">
              Validade: 30 DIAS
            </span>
            <span className="kdent-pdf-prescricao__rodape--bold prescricao__rodape--2">
              Decreto-Lei nº 41/2014
            </span>
          </div>
        </div>

        {/* RODAPÉ INFERIOR */}
        <div className="kdent-pdf-prescricao-rodape--2">
          <span className="kdent-pdf-prescricao-rodape--2__item">
            <span className="kdent-pdf-prescricao--overline">
              Processado por HEALTH TECH CV
            </span>
          </span>
          <span className="kdent-pdf-prescricao-rodape--2__item">
            2368 | Série - Nº 81 «BO» DA REPUBLICA DE CABO VERDE - 31 DE
            DEZEMBRO 2014
          </span>
        </div>
      </div>
    </>
  );
}

export default PdfPrescricaoKDent;
